import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CENBlogSearchQueryState from "@tCentro/Store/Reducer/CENBlogSearchQueryState";
import CENSearchBlogResultState from "@tCentro/Store/Reducer/CENSearchBlogResultState";

import { Draft } from "immer";
 



const initialState: CENSearchBlogResultState = {
    isLoading: false, 
};

export default createTypedReducerWithImmer(initialState, {

    "Custom/CreditMemoData/BeginLoad": (draft: Draft<CENSearchBlogResultState>) => {
        draft.isLoading = true;
    },
    "Custom/CreditMemo/CompletedLoad": (
            draft: Draft<CENSearchBlogResultState>,
            action: {
                result: CENSearchBlogResultState;
            },
        ) => {
            draft.isLoading = false;
        },
});